import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RespondConfirmation } from '../objects/DialogObject';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
import * as i2 from "../objects/DialogObject";
var ConfirmationService = /** @class */ (function () {
    function ConfirmationService(bsModalService, respondConfirmation) {
        this.bsModalService = bsModalService;
        this.respondConfirmation = respondConfirmation;
    }
    ConfirmationService.prototype.confirm = function (title, message, options, input, inputPlaceholder, enableSpeech, validateInput, manualHide, positiveButtonColor) {
        if (input === void 0) { input = false; }
        if (inputPlaceholder === void 0) { inputPlaceholder = ""; }
        if (enableSpeech === void 0) { enableSpeech = false; }
        if (validateInput === void 0) { validateInput = ""; }
        if (manualHide === void 0) { manualHide = false; }
        if (positiveButtonColor === void 0) { positiveButtonColor = ""; }
        var initialState = {
            title: title,
            message: message,
            options: options,
            answer: "",
            input: input,
            inputPlaceholder: inputPlaceholder,
            enableSpeech: enableSpeech,
            validateInput: validateInput,
            manualHide: manualHide,
            positiveButtonColor: positiveButtonColor
        };
        // if (this.bsModalService.getModalsCount() > 0){
        //   document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
        // }
        this.bsModalRef = this.bsModalService.show(ConfirmationDialogComponent, { class: "modal-dialog-centered modal-confirm", ignoreBackdropClick: true, keyboard: false, initialState: initialState });
        document.querySelectorAll('.modal').item(this.bsModalService.getModalsCount() - 1).classList.add('confirm');
        if (document.querySelectorAll('.modal-backdrop').item(0) && this.bsModalService.getModalsCount() > 1) {
            document.querySelectorAll('.modal-backdrop').item(0).classList.add('dark');
        }
        return new Observable(this.getConfirmSubscriber());
    };
    ConfirmationService.prototype.confirmNoInput = function (title, message, options) {
        var initialState = {
            title: title,
            message: message,
            options: options,
            answer: ""
        };
        // if (this.bsModalService.getModalsCount() > 0){
        //   document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
        // }
        //document.querySelectorAll('.modal-backdrop').item(0).classList.add('dark');
        this.bsModalRef = this.bsModalService.show(ConfirmationDialogComponent, { class: "modal-dialog-centered modal-confirm", ignoreBackdropClick: true, keyboard: false, initialState: initialState });
        document.querySelectorAll('.modal').item(this.bsModalService.getModalsCount() - 1).classList.add('confirm');
        if (document.querySelectorAll('.modal-backdrop').item(0) && this.bsModalService.getModalsCount() > 1) {
            document.querySelectorAll('.modal-backdrop').item(0).classList.add('dark');
        }
        return new Observable(this.getConfirmSubscriber());
    };
    ConfirmationService.prototype.confirmTimeout = function (title, message, timeout, options) {
        var initialState = {
            title: title,
            message: message,
            timeout: timeout,
            options: options,
            answer: ""
        };
        if (this.bsModalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
        }
        this.bsModalRef = this.bsModalService.show(ConfirmationDialogComponent, { class: "modal-dialog-centered modal-confirm", ignoreBackdropClick: true, keyboard: false, initialState: initialState });
        return new Observable(this.getConfirmSubscriber());
    };
    ConfirmationService.prototype.getConfirmSubscriber = function () {
        var _this = this;
        return function (observer) {
            var subscription = _this.bsModalService.onHidden.subscribe(function (reason) {
                if (document.querySelectorAll('.modal-backdrop').item(0)) {
                    document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
                    document.querySelectorAll('.modal-backdrop').item(0).classList.remove('dark');
                }
                if (_this.bsModalService.getModalsCount() > 0) {
                    document.querySelectorAll('.modal.fade').item(_this.bsModalService.getModalsCount() - 1).classList.add('show');
                }
                _this.respondConfirmation.inputText = _this.bsModalRef.content.inputText;
                _this.respondConfirmation.answer = _this.bsModalRef.content.answer;
                observer.next(_this.respondConfirmation);
                observer.complete();
            });
            return {
                unsubscribe: function () {
                    subscription.unsubscribe();
                }
            };
        };
    };
    ConfirmationService.ngInjectableDef = i0.defineInjectable({ factory: function ConfirmationService_Factory() { return new ConfirmationService(i0.inject(i1.BsModalService), i0.inject(i2.RespondConfirmation)); }, token: ConfirmationService, providedIn: "root" });
    return ConfirmationService;
}());
export { ConfirmationService };
